import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardCodeDetailTemplate } from 'components/Templates'

const PointCardCodeDetail: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const pointCardCodeId = pathname.split('/point_card/code/')[1]

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'QRコード'} title={'QRコード'}>
      <PointCardCodeDetailTemplate pointCardCodeId={pointCardCodeId} />
    </Layout>
  )
}

export default PointCardCodeDetail
